import React from 'react';

// This function was previously in MainRight.js and is now extracted
const treatmentByline = (t, treatment) => {
  const lowerTreatment = treatment.toLowerCase(); // Normalize to lowercase
  switch (lowerTreatment) {
    case "hyperdry":
      return t('treatment.hyperdry');
    case "expedry":
      return t('treatment.expedry');
    case "ultrawht":
      return t('treatment.ultrawht');
    case "thermadown o2+":
      return t('treatment.thermadownO2Plus');
    default:
      return t('treatment.default');
  }
};

export const DetailTreatmentText = ({ data, t }) => {
  const rawTreatmentValue = Array.isArray(data.treatment) ? data.treatment[0] : data.treatment;
  const treatmentValue = rawTreatmentValue || 'default'; 

  const treatmentTitle = treatmentByline(t, treatmentValue);

  return (
    <>
      <p className="spec-title">{treatmentTitle}</p>
      <p className="spec-value">{rawTreatmentValue}</p>
    </>
  );
};
